import { useRef } from "react";

import { useQuery } from "@tanstack/react-query";

import { calculateAnonymousForecast } from "services";

import { GET_ANONYMOUS_FORECAST, TIMEOUT_LONG_RUNNING } from "consts";

import { CalculateAnonymousForecastRequestBody, CalculateAnonymousForecastResponse } from "models";

// Error UI is handled by the pre-login forecast step, so disable the global toast.
export const useGetAnonymousForecast = (body: CalculateAnonymousForecastRequestBody, enabled: boolean) => {
  const dispatchedRunsRef = useRef(0);

  // react-query arms the abort only when we read `signal`. We leave the first run unarmed, so it always finishes.
  const armAfterFirstRun = (context: { signal: AbortSignal }): AbortSignal | undefined => {
    dispatchedRunsRef.current += 1;
    return dispatchedRunsRef.current > 1 ? context.signal : undefined;
  };

  return useQuery<CalculateAnonymousForecastResponse>({
    queryKey: [GET_ANONYMOUS_FORECAST, body],
    queryFn: (context) => calculateAnonymousForecast(body, { signal: armAfterFirstRun(context), timeout: TIMEOUT_LONG_RUNNING, hideErrorMessage: true }),
    enabled,
    retry: false,
  });
};
